import * as t from "io-ts";

export const ChatConfigValidator = t.intersection([
  t.type({
    enabled: t.boolean,
  }),
  t.partial({
    sendbirdAppId: t.string,
  }),
]);

export type ChatConfig = t.TypeOf<typeof ChatConfigValidator>;
